// src/pages/sow-template/sowTemplateOptions.js
//
// Static option lists for the SOW Template Builder page -- mirrors
// ../rules/ruleOptions.js's role in that feature.

export const SOW_TEMPLATES_PERMS = [
  "sow:templates:view",
  "sow:templates:manage",
  "sow:templates:manage_global",
];

export const SCOPE_OPTIONS = [
  { value: "", label: "All scopes" },
  { value: "global", label: "Global" },
  { value: "org", label: "Org-wide" },
  { value: "account", label: "Account" },
];

export const emptyTemplate = {
  id: null,
  name: "New Template",
  version: "1.0",
  contract_type: "",
  active: true,
  tags_schema_json: {},
  sections_json: [],
  has_docx: false,
};
